/**
 * NDIS Checkout Payment Router
 * Handles routing between standard checkout and NDIS checkout form
 * File: assets/ndis-checkout-router.js
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPaymentRouter);
  } else {
    initPaymentRouter();
  }

  function initPaymentRouter() {
    const paymentSelect = document.getElementById('payment-option-select');
    const checkoutButton = document.getElementById('checkout');

    if (!paymentSelect || !checkoutButton) {
      console.warn('NDIS Router: Payment select or checkout button not found');
      return;
    }

    // Update button text based on selection
    function updateCheckoutButton() {
      const selectedOption = paymentSelect.value;
      
      if (selectedOption === 'ndis-checkout') {
        checkoutButton.textContent = 'Continue to NDIS Checkout';
      } else {
        checkoutButton.textContent = 'Check out';
      }
    }

    // Handle checkout button click
    function handleCheckout(event) {
      const selectedOption = paymentSelect.value;

      if (selectedOption === 'ndis-checkout') {
        // Prevent default form submission
        event.preventDefault();
        event.stopPropagation();
        
        // Redirect to NDIS checkout page
        window.location.href = '/pages/ndis-checkout';
      }
      // If 'pay-now' is selected, allow normal Shopify checkout flow
    }

    // Add event listeners
    paymentSelect.addEventListener('change', updateCheckoutButton);
    checkoutButton.addEventListener('click', handleCheckout);

    // Set initial button text
    updateCheckoutButton();

    console.log('NDIS Payment Router initialized');
  }
})();